<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">
    {{ application.appName }} - Manage Files
  </h4>
  <i
    style="z-index: 1"
    class="bi bi-x-lg text-danger"
    color="warn"
    (click)="onClose()"
    title="Close"
  ></i>
</div>
<div class="modal-body text-grey">
  <form name="uploadAppForm" [formGroup]="uploadAppForm">
    <div class="appFiles">
      <mat-form-field>
        <mat-label>Execute Files</mat-label>
        <mat-select
          formControlName="executeFilesApp"
          multiple
          panelClass="uploadFileSelect"
        >
          <mat-select-trigger>
            {{ uploadAppForm.get("executeFilesApp").value?.[0] || 'None'}}
            <!-- @if ((uploadAppForm.get("executeFilesApp").value?.length || 0) > 1)
            {
            <span class="example-additional-selection">
              (+{{
                (uploadAppForm.get("executeFilesApp").value?.length || 0) - 1
              }}
              {{
                uploadAppForm.get("executeFilesApp").value?.length === 2
                  ? "other"
                  : "others"
              }})
            </span>
            } -->
          </mat-select-trigger>
          @for (executeFile of executeFiles; track executeFile) {
          <mat-option
            [value]="executeFile"
            triggers="hover"
            [ngbTooltip]="executeFile"
            (click)="selectOnlyOneFile(executeFile, 'executeFilesApp')"
            >{{ executeFile }}</mat-option
          >
          } @empty {
          <mat-option
            disabled
            triggers="hover"
            ngbTooltip="No license file available."
            >No execute file available.</mat-option
          >
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>License File</mat-label>
        <mat-select
          formControlName="licenseScript"
          multiple
          panelClass="uploadFileSelect"
        >
          <mat-select-trigger>
            {{ uploadAppForm.get("licenseScript").value?.[0] || 'None'}}
            <!-- @if ((uploadAppForm.get("licenseScript").value?.length || 0) > 1) {
            <span class="example-additional-selection">
              (+{{
                (uploadAppForm.get("licenseScript").value?.length || 0) - 1
              }}
              {{
                uploadAppForm.get("licenseScript").value?.length === 2
                  ? "other"
                  : "others"
              }})
            </span>
            } -->
          </mat-select-trigger>
          @for (licenseFile of licenseFiles; track licenseFile) {
          <mat-option
            [value]="licenseFile"
            triggers="hover"
            [ngbTooltip]="licenseFile"
            (click)="selectOnlyOneFile(licenseFile, 'licenseScript')"
            >{{ licenseFile }}</mat-option
          >
          } @empty {
          <mat-option
            disabled
            triggers="hover"
            ngbTooltip="No license file available."
            >No license file available.</mat-option
          >
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Resume File</mat-label>
        <mat-select
          formControlName="resumeScript"
          multiple
          panelClass="uploadFileSelect"
        >
          <mat-select-trigger>
            {{ uploadAppForm.get("resumeScript").value?.[0] || 'None'}}
            <!-- @if ((uploadAppForm.get("resumeScript").value?.length || 0) > 1) {
            <span class="example-additional-selection">
              (+{{
                (uploadAppForm.get("resumeScript").value?.length || 0) - 1
              }}
              {{
                uploadAppForm.get("resumeScript").value?.length === 2
                  ? "other"
                  : "others"
              }})
            </span>
            } -->
          </mat-select-trigger>
          @for (resumeFile of resumeFiles; track resumeFile) {
          <mat-option
            [value]="resumeFile"
            triggers="hover"
            [ngbTooltip]="resumeFile"
            (click)="selectOnlyOneFile(resumeFile, 'resumeScript')"
            >{{ resumeFile }}</mat-option
          >
          } @empty {
          <mat-option
            disabled
            triggers="hover"
            ngbTooltip="No resume file available."
            >No resume file available.</mat-option
          >
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Cancel File</mat-label>
        <mat-select
          formControlName="cancelScript"
          multiple
          panelClass="uploadFileSelect"
        >
          <mat-select-trigger>
            {{ uploadAppForm.get("cancelScript").value?.[0] || 'None'}}
            <!-- @if ((uploadAppForm.get("cancelScript").value?.length || 0) > 1) {
            <span class="example-additional-selection">
              (+{{
                (uploadAppForm.get("cancelScript").value?.length || 0) - 1
              }}
              {{
                uploadAppForm.get("cancelScript").value?.length === 2
                  ? "other"
                  : "others"
              }})
            </span>
            } -->
          </mat-select-trigger>
          @for (cancelFile of cancelFiles; track cancelFile) {
          <mat-option
            [value]="cancelFile"
            triggers="hover"
            [ngbTooltip]="cancelFile"
            (click)="selectOnlyOneFile(cancelFile, 'cancelScript')"
            >{{ cancelFile }}</mat-option
          >
          } @empty {
          <mat-option
            disabled
            triggers="hover"
            ngbTooltip="No cancel file available."
            >No cancel file available.</mat-option
          >
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Suspend File</mat-label>
        <mat-select
          formControlName="suspendScript"
          multiple
          panelClass="uploadFileSelect"
        >
          <mat-select-trigger>
            {{ uploadAppForm.get("suspendScript").value?.[0] || 'None'}}
            <!-- @if ((uploadAppForm.get("suspendScript").value?.length || 0) > 1) {
            <span class="example-additional-selection">
              (+{{
                (uploadAppForm.get("suspendScript").value?.length || 0) - 1
              }}
              {{
                uploadAppForm.get("suspendScript").value?.length === 2
                  ? "other"
                  : "others"
              }})
            </span>
            } -->
          </mat-select-trigger>
          @for (suspendFile of suspendFiles; track suspendFile) {
          <mat-option
            [value]="suspendFile"
            triggers="hover"
            [ngbTooltip]="suspendFile"
            (click)="selectOnlyOneFile(suspendFile, 'suspendScript')"
            >{{ suspendFile }}</mat-option
          >
          } @empty {
          <mat-option
            disabled
            triggers="hover"
            ngbTooltip="No suspend file available."
            >No suspend file available.</mat-option
          >
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Graph Files</mat-label>
        <mat-select
          formControlName="graphFilesApp"
          multiple
          panelClass="uploadFileSelect"
        >
          <mat-select-trigger>
            {{ uploadAppForm.get("graphFilesApp").value?.[0] || 'None'}}
            <!-- @if ((uploadAppForm.get("graphFilesApp").value?.length || 0) > 1) {
            <span class="example-additional-selection">
              (+{{
                (uploadAppForm.get("graphFilesApp").value?.length || 0) - 1
              }}
              {{
                uploadAppForm.get("graphFilesApp").value?.length === 2
                  ? "other"
                  : "others"
              }})
            </span>
            } -->
          </mat-select-trigger>
          @for (graphFile of graphFiles; track graphFile) {
          <mat-option
            [value]="graphFile"
            triggers="hover"
            [ngbTooltip]="graphFile"
            (click)="selectOnlyOneFile(graphFile, 'graphFilesApp')"
            >{{ graphFile }}</mat-option
          >
          } @empty {
          <mat-option
            disabled
            triggers="hover"
            ngbTooltip="No graph file available."
            >No graph file available.</mat-option
          >
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Custom Action Files</mat-label>
        <mat-select formControlName="customActionFiles" multiple panelClass="uploadFileSelect">
          <mat-select-trigger>
            {{ uploadAppForm.get("customActionFiles").value?.[0] || 'None'}}
            @if ((uploadAppForm.get("customActionFiles").value?.length || 0) > 1) {
              <span class="example-additional-selection">
                (+{{(uploadAppForm.get("customActionFiles").value?.length || 0) - 1}} {{uploadAppForm.get("customActionFiles").value?.length === 2 ? 'other' : 'others'}})
              </span>
            }
          </mat-select-trigger>
          @for (customActionFile of customActionFiles; track customActionFile) {
            <mat-option [value]="customActionFile" triggers="hover" [ngbTooltip]="customActionFile">{{customActionFile}}</mat-option>
          } @empty {
            <mat-option disabled triggers="hover" ngbTooltip="No Custom Action file available.">No Custom Action file available.</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <p 
        *ngIf="uploadAppForm.get('customActionFiles')?.value?.length < (customActionFiles?.length || 0)" 
        class="text-danger float-start" 
        style="font-size: 12px;">
        Deleting Custom Action file will delete the Custom Action
      </p>
      <i
        matTooltip="To add Custom Action, go to Actions dropdown of Application details (Application Details > Actions > Add Custom Action)"
        #tooltip="matTooltip"
        matTooltipPosition="right"
        (click)="tooltip.toggle()"
        [matTooltipHideDelay]="1000"
        class="bi bi-info-circle-fill CustomActionToolTip"
      ></i>
      <!-- <mat-form-field>
        <mat-label>Icon File</mat-label>
        <mat-select formControlName="iconFile">
          <mat-option value="">None</mat-option>
          <mat-option *ngFor="let iconFile of iconFiles" [value]="iconFile"
            >{{ iconFile }}
          </mat-option>
          <mat-option
            *ngIf="iconFiles.length == 0"
            style="color: #7b7777"
            title="No icon File is uploaded for the selected Application."
            disabled
            >No icon file available.</mat-option
          >
        </mat-select>
      </mat-form-field> -->
    </div>

    <br />

    <h4 class="modal-title synchpc-primary" id="modal-title">Upload file</h4>
    <p>Select the file you want to upload to SyncHPC</p>
    <mat-form-field appearance="fill" style="width: 60%">
      <mat-label>File Type</mat-label>
      <mat-select formControlName="fileTypeApp">
        <mat-option *ngFor="let type of types" [value]="type">
          {{ type.name }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          uploadAppForm.get('fileTypeApp').touched &&
          uploadAppForm.get('fileTypeApp').errors
        "
        >Required</mat-error
      >
    </mat-form-field>

    <br />

    <mat-form-field 
    style="width: 60%; background: var(--s-menuHover-color); border-bottom: 1px solid rgba(0,0,0,0.42)" 
    id="ScriptFileReadOnly"
    [ngClass]="{
      'hide-subscript': !uploadAppForm.get('userScriptFile')?.touched || !uploadAppForm.get('userScriptFile')?.errors
    }"
    >
      <mat-label>Script File</mat-label>
      <input
        readonly
        matInput
        placeholder="Script File"
        formControlName="userScriptFile"
      />
    </mat-form-field>

    <div style="display: inline-flex; align-items: center">
      <div style="height: 22px; margin-left: 5px; cursor: pointer; width: 18px">
        <a
          title="Remove"
          (click)="removeFile('userScriptFile')"
          *ngIf="uploadAppForm.get('userScriptFile').value != null"
        >
          <span
            class="bi bi-x-lg text-danger"
            aria-hidden="true"
            style="color: red; font-size: 18px"
          >
          </span>
        </a>
      </div>
      <input
        type="file"
        #chooseAppFile
        style="display: none"
        (click)="onFileChange('chooseAppFile')"
        (change)="uploadFiles($event?.target?.files[0], 'userScriptFile')"
      />
      <button
        type="button"
        title="Select and upload file"
        class="bi bi-cloud-arrow-up pull-right uploadBtn"
        (click)="chooseAppFile.click()"
      >
        Upload File
      </button>
      <button
        type="button"
        id="btnUploadFile"
        title="Select and upload files to working directory"
        class="uploadBtn pull-right"
        style="outline: none"
        (click)="createNewFile()"
      >
        <span class="bi bi-pencil"></span>
        New File
      </button>
    </div>
    <br />
    <p *ngIf="toShow" style="float: left" class="uploadPercentage">
      Uploaded : {{ scriptFileUploadPer }}%
    </p>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onClose()">
    Close
  </button>
  <button
    [disabled]="submitActive || !uploadAppForm.dirty"
    type="submit"
    class="btn btn-primary"
    (click)="onSubmit()"
  >
    Submit
  </button>
</div>
